<template>
  <div id="goTop">
    <Header :url="url"></Header>
    <van-swipe :autoplay="3000" style="margin-top:1rem">
      <van-swipe-item v-for="(image, index) in images" @click="tolink(image)" :key="index">
        <img class="banner" :src="image.posterImg" alt />
      </van-swipe-item>
    </van-swipe>
    <div class="desc">
      <h1 class="title desc__title">公司简介</h1>
      <p class="desc__p">
        深圳麦德通商务技术有限公司，是欧税通集团旗下子公司，成立于2020年10月，专注于企业知识产权合规服务。公司于2022年3月正式推出麦德通(IPPMASTER：Intellectual Property Protection) 跨境电商知识产权合规服务平台，通过“AI大数据”+“AI智能合规服务”模式，全面监控管理商标、专利、著作权相关的客户、案件、时限、费用等板块。全流程可视化、费用透明化、操作简单化、数字智能化，有力防范企业知识产权法律风险，使企业的知识产权业务向规范化、信息化和无纸化方向发展，为企业赢得竞争优势。
      </p>
      <p class="desc__p">
        目前麦德通主打美国、英国、欧盟、日本等国际商标注册服务。团队在商标申请、答辩、申诉、侵权取证等方面具有多年实操经验。麦德通专注跨境电商知识产权合规服务，致力为客户品牌智造出海保驾护航！
      </p>
    </div>
    <div class="culture">
      <h1 class="title culture__title">公司文化</h1>
      <ul class="culture__list">
        <li class="culture__item">
          <div>
            <img class="culture__item-icon" src="../assets/icon/heart.png" alt="">
          </div>
          <div class="culture__item_right">
            <p class="culture__item-key">使命</p>
            <p class="culture__item-desc">为跨境企业健康出海保驾护航</p>
          </div>
        </li>
        <li class="culture__item">
          <div>
            <img class="culture__item-icon" src="../assets/icon/light.png" alt=""></img>
          </div>
          <div class="culture__item_right">
            <p class="culture__item-key">愿景</p>
            <p class="culture__item-desc">参与全球每一笔跨境业务</p>
          </div>
        </li>
        <li class="culture__item">
          <div>
            <img class="culture__item-icon" src="../assets/icon/masonry.png" alt="">
          </div>
          <div class="culture__item_right">
            <p class="culture__item-key">价值观</p>
            <p class="culture__item-desc">专业、创新、诚信、共赢</p>
          </div>
        </li>
        <li class="culture__item">
          <div>
            <img class="culture__item-icon" src="../assets/icon/idea.png" alt="">
           </div>
           <div class="culture__item_right">
            <p class="culture__item-key">经营理念</p>
            <p class="culture__item-desc">成就客户、拥抱变化</p>
           </div>
        </li>
      </ul>
    </div>
    <div class="advantage">
      <h1 class="title advantage__title">我们的优势</h1>
      <ul class="advantage__list">
        <li class="advantage__item">
          <img class="advantage__item-icon" src="../assets/icon/api.png" alt="">
          <div class="advantage__item-info">
            <div class="advantage__item-title">API直连多国商标局</div>
            <div class="advantage__item-desc">API直连美国、日本等多国商标局系统，秒出查询结果</div>
          </div>
        </li>
        <li class="advantage__item">
          <img class="advantage__item-icon" src="../assets/icon/security.png" alt="">
          <div class="advantage__item-info">
            <div class="advantage__item-title">保障信息数据安全</div>
            <div class="advantage__item-desc">DDoS、WAF、硬件三重防火墙隔离病毒，全方位抵御网络非法入侵,1对1专属服务</div>
          </div>
        </li>
        <li class="advantage__item">
          <img class="advantage__item-icon" src="../assets/icon/iso.png" alt="">
          <div class="advantage__item-info">
            <div class="advantage__item-title">ISO/IEC认证</div>
            <div class="advantage__item-desc">信息安全、隐私信息、信息技术服务三项国际标准管理体系认证，安全隐私达国际领先标准</div>
          </div>
        </li>
        <li class="advantage__item">
          <img class="advantage__item-icon" src="../assets/icon/1v1.png" alt="">
          <div class="advantage__item-info">
            <div class="advantage__item-title">1对1专属服务</div>
            <div class="advantage__item-desc">每一位注册用户，均有专属顾问，1对1跟踪服务</div>
          </div>
        </li>
        <li class="advantage__item">
          <img class="advantage__item-icon" src="../assets/icon/lawer.png" alt="">
          <div class="advantage__item-info">
            <div class="advantage__item-title">资深律师团队</div>
            <div class="advantage__item-desc">多国13年+国际知识产权律师团队为商标服务保驾护航</div>
          </div>
        </li>
      </ul>
    </div>
    <Footer></Footer>
    <div v-if="scrollTop" @click="scrollToTop" class="to-top">
      <img src="/static/img/icon/toTop.png" alt />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { throttle } from '@/util/util'
import { getSysPosterConfigList, adRecordBanner } from '@/api/land.js'
export default {
  components: { Header, Footer },
  data () {
    return {
      scrollTop: false,
      url: '/aboutUs',
      images: []
    }
  },
  created () {
    document.documentElement.scrollTop = 0
    document.title = '关于我们-麦德通—一站式VAT自主申报平台'
    this.getImgList()
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    getImgList () {
      getSysPosterConfigList({ module: 2, status: 1, showPageNames: 'about' })
        .then(res => {
          if (res.code == 0) {
            if (res.data && res.data.length > 0) {
              res.data.sort(function (a, b) {
                return a.sort - b.sort
              })
              let list = []
              res.data.forEach(i => {
                list.push({
                  posterId: i.posterId,
                  incrViewCount: 1
                })
              })
              adRecordBanner(list).then()
              this.images = res.data
            }
          } else {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          }
        })
        .catch(() => {
          // this.$toast({ message: '系统繁忙，请稍后重试' })
        })
    },
    tolink (e) {
      if (e.showType == '1') {
        adRecordBanner([{ posterId: e.posterId, incrClickCount: 1 }]).then()
        let href = e.showWay
        if (href.indexOf('http') != -1 || href.indexOf('https') != -1) {
          window.open(e.showWay, '_blank')
        } else {
          if (
            this.phoneInfo.indexOf('Windows') != -1 ||
            this.phoneInfo.indexOf('Macintosh') != -1
          ) {
            this.$toast({ message: '请用手机端打开' })
          } else {
            linkToProgram({ path: href })
              .then(res => {
                if (res.code == 0) {
                  window.location.href = res.data
                } else {
                  this.$toast({ message: '系统繁忙，请稍后重试' })
                }
              })
              .catch(() => {
                this.$toast({ message: '系统繁忙，请稍后重试' })
              })
          }
        }
      }
    },
    scrollToTop () {
      setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 300)
    },
    handleScroll: throttle(function () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
      if (scrollTop > 500) {
        this.scrollTop = true
      } else {
        this.scrollTop = false
      }
    }, 500)
  }

}
</script>

<style lang="less" scoped>
#goTop {
  text-size-adjust: none;
  font-family: PingFang SC;
}

.logo-img {
  width: 100%;
}

.logo {
  height: 1.5rem;
  background: linear-gradient(#b4ceff, #206cf7);
  text-align: center;
  font-size: .42rem;
  line-height: 1.5rem;
  color: #FFFFFF;
}

.title {
  text-align: center;
  font-family: PingFang SC;
  font-size: .36rem;
  font-weight: 700;
  line-height: 1;
  color: #333333;
}

.desc {
  box-sizing: border-box;
  padding: .61rem .35rem;

  &__title {
    margin-bottom: .36rem;
  }

  &__p {
    text-align: left;
    font-family: PingFang SC;
    font-size: .28rem;
    font-weight: 400;
    color: #666666;
    line-height: .46rem;

    & + .desc__p {
      margin-top: .4rem;
    }
  }
}

.culture {
  box-sizing: border-box;
  padding: .47rem .38rem .5rem;
  background: #F8F8F9;

  &__title {
    margin-bottom: .4rem;
  }

  &__list {
    list-style: none;
  }

  &__item {
    display: flex;
    align-items: center;

    box-sizing: border-box;
    height: 1.1rem;
    padding-left: .42rem;
    background: #FFFFFF;
    &_right {
      margin-left: 0.25rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
    &:nth-child(n + 2) {
      margin-top: .2rem;
    }

    &-icon {
      width: .46rem;
      height: auto;
    }

    &-key {
      font-size: .32rem;
      line-height: 1;
      font-family: PingFang SC;
      font-weight: bold;
      color: #1363F7;
      margin-bottom: .16rem;
    }

    &-desc {
      font-family: PingFang SC;
      font-size: .28rem;
      line-height: 1;
      font-weight: 400;
      color: #666666;
      margin-bottom: 0;
    }
  }
}

.advantage {
  box-sizing: border-box;
  padding: .5rem .35rem;
  background: #fff;

  &__title {
    margin-bottom: .07rem;
  }

  &__list {
    list-style: none;
  }

  &__item {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 1.32rem;
    padding: 0 .46rem;
    border-bottom: 1px dotted #B9B9B9;

    &-icon {
      width: .74rem;
      height: auto;
    }

    &-info {
      margin-left: .4rem;
      text-align: left;
    }

    &-title {
      text-size-adjust: none;
      font-family: PingFang SC;
      margin-bottom: .14rem;
      font-size: .24rem;
      font-weight: 400;
      line-height: .36rem;
      color: #333333;
    }

    &-desc {
      text-size-adjust: none;
      font-family: PingFang SC;
      font-size: .20rem;
      font-weight: 300;
      line-height: .28rem;
      color: #717171;
    }
  }
}

img {
  width: 100%;
}
.to-top {
  position: fixed;
  width: 1rem !important;
  right:5px;
  bottom: 148px;
  height: 1rem !important;
  display: inline-block;
  border-radius: 100%;
  background: white;
  box-shadow: 10px 10px 70px gray;
}
.to-top img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs.vue